/* ===================================================================
   Studio Booth theme — behaviors
   Header sticky + mobile drawer, scroll reveal, looping video,
   count-up stats, team modal, careers résumé upload.
   Icons injected from window.SBIcon (sb-icons.js).
   =================================================================== */
(function(){
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    var I = window.SBIcon || function(){return '';};

    // ---- icons ----
    document.querySelectorAll('[data-i]').forEach(function(e){
      var sz = e.dataset.sz ? +e.dataset.sz : (e.classList.contains('ic') ? 19 : 22);
      var st = e.dataset.stroke ? +e.dataset.stroke : 1.5;
      e.innerHTML = I(e.dataset.i, {size:sz, stroke:st});
    });
    // star rows
    document.querySelectorAll('[data-stars]').forEach(function(e){
      var n = +e.dataset.stars || 5;
      e.innerHTML = new Array(n).fill(I('star-filled',{size:+e.dataset.sz||15})).join('');
    });

    // ---- header sticky + sticky book fab ----
    var hd = document.getElementById('hd'), fab = document.getElementById('fab');
    function onScroll(){ if(hd) hd.classList.toggle('solid', scrollY>30); if(fab) fab.classList.toggle('on', scrollY>560); }
    onScroll(); addEventListener('scroll', onScroll, {passive:true});

    // ---- scroll reveal ----
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} }); }, {threshold:.1});
      document.querySelectorAll('.reveal').forEach(function(e){ io.observe(e); });
    } else { document.querySelectorAll('.reveal').forEach(function(e){ e.classList.add('in'); }); }

    // ---- mobile drawer ----
    var drawer=document.getElementById('drawer'), menuBtn=document.getElementById('menuBtn'),
        scrim=document.getElementById('drawerScrim'), closeBtn=document.getElementById('drawerClose');
    if(closeBtn) closeBtn.innerHTML = I('close',{size:20,stroke:2});
    function openD(){ drawer.classList.add('open'); if(menuBtn) menuBtn.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; }
    function closeD(){ drawer.classList.remove('open'); if(menuBtn) menuBtn.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }
    if(menuBtn) menuBtn.addEventListener('click', openD);
    if(closeBtn) closeBtn.addEventListener('click', closeD);
    if(scrim) scrim.addEventListener('click', closeD);
    if(drawer) drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeD); });
    addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeD(); closeModal(); } });
    addEventListener('resize', function(){ if(innerWidth>1000 && drawer) closeD(); });

    // ---- looping video autoplay ----
    var vids = [].slice.call(document.querySelectorAll('video'));
    function play(v){ v.muted=true; v.loop=true; var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
    vids.forEach(function(v){
      if(v.readyState>=2) play(v);
      v.addEventListener('loadeddata', function(){ play(v); }, {once:true});
      v.addEventListener('canplay', function(){ play(v); });
      v.addEventListener('ended', function(){ v.currentTime=0; play(v); });
    });
    if('IntersectionObserver' in window){
      var vio = new IntersectionObserver(function(es){ es.forEach(function(e){ e.isIntersecting ? play(e.target) : e.target.pause(); }); }, {threshold:.15});
      vids.forEach(function(v){ vio.observe(v); });
    }
    var resume = function(){ vids.forEach(play); removeEventListener('pointerdown', resume); removeEventListener('touchstart', resume); };
    addEventListener('pointerdown', resume, {passive:true, once:true});
    addEventListener('touchstart', resume, {passive:true, once:true});

    // ---- count-up stats ----
    function countUp(el){
      var to = parseFloat(el.dataset.to||'0'), dec = +el.dataset.dec||0, suf = el.dataset.suf||'', s=0, step=to/40;
      var t = setInterval(function(){ s+=step; if(s>=to){ s=to; clearInterval(t);} el.textContent = (dec?s.toFixed(dec):Math.floor(s).toLocaleString())+suf; }, 26);
    }
    var stats = document.querySelectorAll('[data-to]');
    if(stats.length && 'IntersectionObserver' in window){
      var sio = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ countUp(e.target); sio.unobserve(e.target);} }); }, {threshold:.4});
      stats.forEach(function(e){ sio.observe(e); });
    } else { stats.forEach(countUp); }

    // ---- team modal ----
    var modal = document.getElementById('tmodal');
    function openModal(slug){
      var data = document.getElementById('mdata-'+slug);
      if(!data || !modal) return;
      modal.querySelector('.panel').innerHTML =
        '<button class="x" aria-label="Close">'+I('close',{size:20,stroke:2})+'</button>'+
        '<div class="pic">'+ (data.dataset.img ? '<img src="'+data.dataset.img+'" alt="'+data.dataset.name+'">' : '<div class="mono">'+data.dataset.name.charAt(0)+'</div>') +'</div>'+
        '<div class="body"><h3>'+data.dataset.name+'</h3><p class="role">'+data.dataset.role+'</p>'+
          '<div class="bio">'+data.innerHTML+'</div>'+
          (data.dataset.tags ? '<div class="tags">'+ data.dataset.tags.split('|').map(function(t){return '<span>'+t+'</span>';}).join('') +'</div>' : '')+
          '<div style="margin-top:24px"><a class="btn noir" href="'+(window.SB_BOOK||'#')+'" target="_blank" rel="noopener">Book with us</a></div>'+
        '</div>';
      modal.querySelector('.x').addEventListener('click', closeModal);
      modal.classList.add('open'); document.body.style.overflow='hidden';
    }
    function closeModal(){ if(modal){ modal.classList.remove('open'); document.body.style.overflow=''; } }
    document.querySelectorAll('[data-member]').forEach(function(b){ b.addEventListener('click', function(){ openModal(b.dataset.member); }); });
    if(modal) modal.querySelector('.scrim').addEventListener('click', closeModal);

    // ---- services sub-nav: prefill role on careers, smooth anchor ----
    document.querySelectorAll('[data-role-link]').forEach(function(a){
      a.addEventListener('click', function(){ var sel=document.getElementById('rl'); if(sel) sel.value=a.dataset.roleLink; });
    });

    // ---- careers résumé upload ----
    var rz=document.getElementById('rz'), upLabel=document.getElementById('upLabel'), upText=document.getElementById('upText');
    if(rz && upLabel){
      var showFile=function(f){ if(f){ upText.innerHTML='Attached: <b>'+f.name+'</b> — click to change'; upLabel.classList.add('has'); } };
      rz.addEventListener('change', function(){ showFile(rz.files[0]); });
      ['dragover','dragenter'].forEach(function(ev){ upLabel.addEventListener(ev, function(e){ e.preventDefault(); upLabel.classList.add('drag'); }); });
      ['dragleave','drop'].forEach(function(ev){ upLabel.addEventListener(ev, function(e){ e.preventDefault(); upLabel.classList.remove('drag'); }); });
      upLabel.addEventListener('drop', function(e){ if(e.dataTransfer.files[0]){ rz.files=e.dataTransfer.files; showFile(rz.files[0]); } });
    }
  });
})();
